export default __webpack_public_path__ + "static/media/location.940a514d.svg";